// import React, { useEffect, useState } from 'react';

// function Links({ LinksContent, LanguageSelected, t, ImageUrl, hashedUserId, img5, divstyle }) {
   

//     return (
//         <div>
//             {LinksContent && LinksContent.length > 0 && (
//                 <div className={`${divstyle} ${LanguageSelected == 'ar' ? 'erlDiv' : ''} pt-5 pb-5 pl-3 pr-3  `}>
//                     {/* Appoinetement */}
//                     <h1
//                         className={`${LanguageSelected == 'ar'
//                                 ? 'title title--h1 first-title title__separate text-theme right-2.5'
//                                 : 'title left-2.5 title--h1 first-title title__separate text-theme'
//                             }`}
//                     >
//                         {t("Liens")}
//                     </h1>
//                     <div className="">
//                         <div className="p-2 ">
//                             {/* Item review */}
//                             {LinksContent.map((link, index) => (
//                                 <div className={`mb-3 flex ${divstyle == 'sections' ? 'div-sections' : 'sections'} flex-col review-ite flex-none w-full md:w-1/2 lg:w-1/3 `} key={index}>
//                                     <div className="flex flex-col ">
//                                         <a href={link.url} target='_blank' className="flex relative justify-between gap-2   items-center ">
//                                             <div
//                                                 className="w-1/3 flex justify-center items-center p-1 rounded-full"
//                                                 style={{
//                                                     backgroundImage: `url(${link.image !== null ? `${ImageUrl}/${hashedUserId}/${link.image}` : img5})`,
//                                                     backgroundSize: "cover",
//                                                     width: "6rem", // Set your desired default width
//                                                     height: "4.5rem", // Set your desired default height
//                                                 }}
//                                             ></div>
//                                             <div className='w-full justify-start items-center mr-2 '>
//                                                 <h4 className="text-theme title text-start leading-none title--h5 ">{link.title}</h4>
//                                                 <p className="review-item__caption text-about text-theme mt-1">{link.description}</p>
//                                             </div>
//                                             {LanguageSelected == "ar" ?
//                                                 (

//                                                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
//                                                         <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
//                                                     </svg>


//                                                 )
//                                                 :
//                                                 (

//                                                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
//                                                         <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
//                                                     </svg>


//                                                 )



//                                             }
//                                         </a>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default Links;
import React from 'react';

function Links({ LinksContent, LanguageSelected, t, ImageUrl, hashedUserId, img5, divstyle }) {
    
    // Helper to get language-specific text
    const getText = (textObj) => {
        if (!textObj) return '';
        if (typeof textObj === 'object' && textObj !== null) {
            return textObj[LanguageSelected] || '';
        }
        return textObj || '';
    };

    // Check valid content
    const hasValidContent = (link) => {
        const title = getText(link.title);
        const description = getText(link.description);
        return title.trim() !== '' || description.trim() !== '';
    };

    if (!LinksContent || LinksContent.length === 0) return null;

    const validLinks = LinksContent.filter(hasValidContent);
    if (validLinks.length === 0) return null;

    return (
        <div>
            <div className={`${divstyle} ${LanguageSelected === 'ar' ? 'erlDiv' : ''} pt-5 pb-5 pl-3 pr-3`}>
                <h1
                    className={`${
                        LanguageSelected === 'ar'
                            ? 'title title--h1 first-title title__separate text-theme right-2.5'
                            : 'title left-2.5 title--h1 first-title title__separate text-theme'
                    }`}
                >
                    {t("Liens")}
                </h1>
                
                <div className="">
                    <div className="p-2">
                        {validLinks.map((link, index) => {
                            const linkTitle = getText(link.title);
                            const linkDescription = getText(link.description);

                            return (
                                <div 
                                    className={`mb-3 flex ${divstyle === 'sections' ? 'div-sections' : 'sections'} flex-col review-ite flex-none w-full md:w-1/2 lg:w-1/3`} 
                                    key={link.id || index}
                                >
                                    <div className="flex flex-col">
                                        <a 
                                            href={link.url} 
                                            target='_blank' 
                                            rel="noopener noreferrer"
                                            className="flex relative justify-between gap-2 items-center"
                                        >
                                            <div
                                                className="w-1/3 flex justify-center items-center p-1 rounded-full"
                                                style={{
                                                    backgroundImage: `url(${
                                                        link.image !== null 
                                                            ? `${ImageUrl}/${hashedUserId}/${link.image}` 
                                                            : img5
                                                    })`,
                                                    backgroundSize: "cover",
                                                    width: "6rem",
                                                    height: "4.5rem",
                                                }}
                                            ></div>
                                            
                                            <div className='w-full justify-start items-center mr-2'>
                                                <h4 
                                                    className={`text-theme title text-start leading-none title--h5 ${
                                                        LanguageSelected === 'ar' ? 'text-right' : 'text-left'
                                                    }`}
                                                    dir={LanguageSelected === 'ar' ? 'rtl' : 'ltr'}
                                                >
                                                    {linkTitle || t('Untitled')}
                                                </h4>
                                                <p 
                                                    className={`review-item__caption text-about text-theme mt-1 ${
                                                        LanguageSelected === 'ar' ? 'text-right' : 'text-left'
                                                    }`}
                                                    dir={LanguageSelected === 'ar' ? 'rtl' : 'ltr'}
                                                >
                                                    {linkDescription}
                                                </p>
                                            </div>
                                            
                                            {LanguageSelected === "ar" ? (
                                                <svg 
                                                    xmlns="http://www.w3.org/2000/svg" 
                                                    fill="none" 
                                                    viewBox="0 0 24 24" 
                                                    strokeWidth="1.5" 
                                                    stroke="currentColor" 
                                                    className="w-8 h-8"
                                                >
                                                    <path 
                                                        strokeLinecap="round" 
                                                        strokeLinejoin="round" 
                                                        d="M15.75 19.5L8.25 12l7.5-7.5" 
                                                    />
                                                </svg>
                                            ) : (
                                                <svg 
                                                    xmlns="http://www.w3.org/2000/svg" 
                                                    fill="none" 
                                                    viewBox="0 0 24 24" 
                                                    strokeWidth="1.5" 
                                                    stroke="currentColor" 
                                                    className="w-8 h-8"
                                                >
                                                    <path 
                                                        strokeLinecap="round" 
                                                        strokeLinejoin="round" 
                                                        d="M8.25 4.5l7.5 7.5-7.5 7.5" 
                                                    />
                                                </svg>
                                            )}
                                        </a>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Links;